import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardBody } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFire } from '@fortawesome/free-solid-svg-icons'
import Flex from '../../common/Flex'
import { formatBonusPercent, formatPeriod } from '../rewardsUtils'

const StreakCard = ({ summary }) => {
  const months = Number(summary.current_streak_months) || 0
  const bestMonths = Number(summary.best_streak_months) || 0
  const multiplier = Number(summary.streak_multiplier) || 1
  const hasBonus = multiplier > 1
  const lastPeriod = formatPeriod(summary.last_qualified_payment_period)

  return (
    <Card className="h-100">
      <CardBody>
        <Flex align="center">
          <div
            className={`d-flex flex-center rounded-circle mr-3 flex-shrink-0 ${months > 0 ? 'bg-soft-danger text-danger' : 'bg-soft-secondary text-500'}`}
            style={{ width: '3rem', height: '3rem' }}
          >
            <FontAwesomeIcon icon={faFire} className="fs-2" />
          </div>
          <div className="flex-grow-1">
            <h6 className="text-600 mb-1">Racha de puntualidad</h6>
            <h4 className="mb-0">
              {months} {months === 1 ? 'mes' : 'meses'}
            </h4>
          </div>
          {hasBonus && (
            <span className="badge badge-soft-success rounded-capsule fs--1 ml-2" title="Bono activo sobre las Coins que ganas">
              {formatBonusPercent(multiplier)} Coins
            </span>
          )}
        </Flex>
        <p className="fs--1 mb-0 mt-3 text-600">
          {months > 0
            ? 'Sigue pagando tu cuota a tiempo para no perder tu racha.'
            : 'Aún no tienes una racha activa. Paga tu cuota a tiempo para empezar una.'}
          {lastPeriod && <> Último mes puntual: <b className="text-900">{lastPeriod}</b>.</>}
          {bestMonths > months && <> Tu mejor racha: {bestMonths} meses.</>}
        </p>
      </CardBody>
    </Card>
  )
}

StreakCard.propTypes = { summary: PropTypes.object.isRequired }

export default StreakCard
